<ng-container *ngIf="location">

    <div class="details-section">
        <div class="section-header">General</div>
        <div class="section-content">
        <div class="section-tab">
            <div class="row"><div class="col1">Name:</div><div class="col">{{ location.name }}</div></div>
            <div class="row"><div class="col1">Identifier:</div><div class="col">{{ location.id }}</div></div>
            <div class="row"><div class="col1">Type:</div><div class="col">{{ location.type }}</div></div>
            <div class="row"><div class="col1">Info:</div><div class="col">{{ location.info }}</div></div>
        </div> 
        </div>
        <div class="section-header">Additional</div>
        <div class="section-content">
        <div class="section-tab">
            <div class="row"><div class="col1">Environment Clearness Level:</div><div class="col">{{ location.environmentClearnessLevel }}</div></div>
            <div class="row"><div class="col1">Factor Risk Level:</div><div class="col">{{ location.factorRiskLevel  }}</div></div>
            <div class="row"><div class="col1">Temperature stress:</div><div class="col">{{ location.temperatureStress  }}</div></div>            
        </div>         
        </div>
        <div class="section-header">Geolocation</div>
        <div class="section-content">
        <div class="section-tab">
            <div class="row"><div class="col1">Latitude:</div><div class="col">{{ location.gpsLatitude }}</div></div>
            <div class="row"><div class="col1">Longitude:</div><div class="col">{{ location.gpsLongitude }}</div></div>
        </div>         
        </div>
    </div>

</ng-container> 